import React from 'react';
import SelectionContext from '../contexts/selection-context';

export default Component => () => (
  <SelectionContext.Consumer>
    { selectRow => <Component { ...selectRow } /> }
  </SelectionContext.Consumer>
);



// WEBPACK FOOTER //
// ./packages/react-bootstrap-table2/src/row-selection/selection-header-cell-consumer.js